
ADILF.define('adilf/apps/profile/views/content-summary-view',['require','exports','module','streamhub-sdk/jquery','adilf/context','inherits','streamhub-sdk/view','hgn!adilf/apps/profile/templates/content-summary-view'],function (require, exports, module) {'use strict';

var jquery = require('streamhub-sdk/jquery');
var Context = require('adilf/context');
var inherits = require('inherits');
var View = require('streamhub-sdk/view');
var template = require('hgn!adilf/apps/profile/templates/content-summary-view');

var ProfileSummaryView = function (opts) {
    opts = opts || {};
    View.call(this, opts);
    this._prefix = opts.prefix;
    this.content = opts.content;
};
inherits(ProfileSummaryView, View);

ProfileSummaryView.prototype.template = template;
ProfileSummaryView.prototype.elTag = 'section';
ProfileSummaryView.prototype.elClass = 'content-summary';

ProfileSummaryView.prototype.formatDate = function (createdAt) {
    var hours = createdAt.getHours();
    var minutes = createdAt.getMinutes();
    var formattedDate = "{month}/{date}/{year} {hour}:{minute} {ampm}"
        .replace('{month}', createdAt.getMonth() + 1)
        .replace('{date}', createdAt.getDate())
        .replace('{year}', createdAt.getFullYear())
        .replace('{hour}', (hours % 12) ? hours % 12 : 12)
        .replace('{minute}', (minutes < 10) ? '0'+minutes : minutes)
        .replace('{ampm}', (hours >= 12) ? 'PM' : 'AM');
    return formattedDate;
};

ProfileSummaryView.prototype.getTemplateContext = function () {
    var context = jquery.extend({}, this.content);
    context.prefix = this._prefix;
    context.type = (this.content.meta.collection.url && 
                    !this.content.meta.collection.url.match(/(events|highschoolsports|\/\d\d\d\d\/\d\d\/)/)) ? 
                        "text" : 
                        "comment";
    if (this.content && this.content.createdAt) {
        context.formattedCreatedAt = this.formatDate(this.content.createdAt);
    }
    context.body = context.body.replace('advance.net/user/', Context.affiliate.domain+'/user/');
    return context;
};

module.exports = ProfileSummaryView;

});
